import { render, staticRenderFns } from "./CustomQuestionsTable.vue?vue&type=template&id=daeb6672&scoped=true"
import script from "./CustomQuestionsTable.vue?vue&type=script&lang=js"
export * from "./CustomQuestionsTable.vue?vue&type=script&lang=js"
import style0 from "./CustomQuestionsTable.vue?vue&type=style&index=0&id=daeb6672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daeb6672",
  null
  
)

export default component.exports